<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()">
  <app-cycle-navigation></app-cycle-navigation>
  <div class="cycle-item__container">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</agr-page-detail>
